// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import {
  CoachCardCoachFragmentDoc,
  CoachCardOfferingPackageFragmentDoc,
  CoachCardSkuFragmentDoc,
  CoachCardHydratedCoachFieldsFragmentDoc,
} from './CoachCard.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CoachListCoachFragment = {
  __typename?: 'Coach';
  id: string;
  slug: string;
  tier: Types.SkuTier;
  bio?: string | null;
  hourlyRate?: number | null;
  reviewTotal: number;
  averageReviewRate: number;
  isSuperCoach?: boolean | null;
  totalCoachingMinutes: number;
  isSaved?: boolean | null;
  couldScheduleIntro?: boolean | null;
  everHadCoachingSessionWithCoach?: boolean | null;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
  };
  categoryInformationList?: Array<{
    __typename?: 'CategoryInformation';
    id: string;
    headline?: string | null;
    testScore?: number | null;
    qualifications?: string | null;
    category: {
      __typename?: 'Category';
      id: string;
      slug: string;
      name: string;
      goal: Types.GoalName;
    };
  }> | null;
  availability?: {
    __typename?: 'CoachAvailability';
    nextAvailableAt?: number | null;
  } | null;
  educationExperiences?: Array<{
    __typename?: 'Education';
    admissionCommittee: boolean;
    isFeatured?: boolean | null;
    school: {
      __typename?: 'School';
      id: string;
      name: string;
      logoLink?: string | null;
    };
  }> | null;
  professionalExperiences?: Array<{
    __typename?: 'ProfessionalExperience';
    experienceType?: Types.ExperienceType | null;
    isFeatured?: boolean | null;
    company: {
      __typename?: 'Company';
      id?: string | null;
      name: string;
      domain?: string | null;
      logoLink?: string | null;
    };
    endAt?: { __typename?: 'MonthYear'; year: number } | null;
  }> | null;
  outcomes?: Array<
    | {
        __typename?: 'CareerOutcomeSummary';
        companies: Array<{
          __typename?: 'Company';
          id?: string | null;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | {
        __typename?: 'SchoolOutcomeSummary';
        schools: Array<{
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | {
        __typename?: 'TestOutcomeSummary';
        scoreRange?: string | null;
        category: { __typename?: 'Category'; id: string };
      }
  > | null;
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
    paidTimeInMinute?: number | null;
    customerSubscription?: {
      __typename?: 'CustomerSubscription';
      id: string;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    } | null;
  } | null;
  badges?: Array<{
    __typename?: 'Badge';
    id: string;
    type: Types.BadgeType;
    categoryUrn?: string | null;
  }> | null;
  schoolAdmissionInfoList?: Array<{
    __typename?: 'SchoolAdmissionInfo';
    status?: Types.SchoolAdmissionStatus | null;
    school: {
      __typename?: 'School';
      id: string;
      name: string;
      logoLink?: string | null;
    };
  }> | null;
  companiesAdmitted?: Array<{
    __typename?: 'Company';
    id?: string | null;
    name: string;
    domain?: string | null;
    logoLink?: string | null;
  }> | null;
  coachingTimeSummary?: {
    __typename?: 'CoachingTimeSummary';
    availableTime: number;
    hasUnlimitedPackage: boolean;
    cycles?: Array<{
      __typename?: 'SubscriptionCycle';
      timeInMinute: number;
      start?: number | null;
      end?: number | null;
    }> | null;
  } | null;
};

export type CoachListCategoryFragment = {
  __typename?: 'Category';
  id: string;
  slug: string;
};

export type CoachListLelandPlusContributorCoachBatchResponseFragment = {
  __typename?: 'CoachBatchResponse';
  total: number;
  results: Array<{
    __typename?: 'Coach';
    id: string;
    slug: string;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
    };
  }>;
};

export type CoachListOfferingPackageFragment = {
  __typename?: 'OfferingPackage';
  id: string;
  slug?: string | null;
  name: string;
  imageLink?: string | null;
  prices?: Array<{
    __typename?: 'OfferingPackagePrice';
    sku?: string | null;
    price: number;
    packageCoachingTime?: {
      __typename?: 'PackageCoachingTime';
      exactTimeInMinute?: number | null;
      estimate?: {
        __typename?: 'IntRange';
        start?: number | null;
        end?: number | null;
      } | null;
    } | null;
  }> | null;
};

export type CoachListSkuFragment = {
  __typename?: 'Sku';
  id: string;
  tier: Types.SkuTier;
  unitPrice: number;
};

export type CoachListUserQueryVariables = Types.Exact<{ [key: string]: never }>;

export type CoachListUserQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    applicant?: {
      __typename?: 'Applicant';
      id: string;
      hasLelandPlusAccess?: boolean | null;
    } | null;
  } | null;
};

export type CoachListHydratedCoachFieldsFragment = {
  __typename?: 'Coach';
  id: string;
  tier: Types.SkuTier;
  hourlyRate?: number | null;
  couldScheduleIntro?: boolean | null;
  isSaved?: boolean | null;
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
  } | null;
};

export type CoachListHydratedCoachesBySlugsQueryVariables = Types.Exact<{
  coachUrns:
    | Array<Types.Scalars['String']['input']>
    | Types.Scalars['String']['input'];
}>;

export type CoachListHydratedCoachesBySlugsQuery = {
  __typename?: 'Query';
  coachesBySlugs: Array<{
    __typename?: 'Coach';
    id: string;
    tier: Types.SkuTier;
    hourlyRate?: number | null;
    couldScheduleIntro?: boolean | null;
    isSaved?: boolean | null;
    coachingRelationship?: {
      __typename?: 'CoachingRelationship';
      id: string;
    } | null;
  }>;
};

export const CoachListCoachFragmentDoc = gql`
  fragment CoachList_Coach on Coach {
    id
    ...CoachCard_Coach
  }
  ${CoachCardCoachFragmentDoc}
`;
export const CoachListCategoryFragmentDoc = gql`
  fragment CoachList_Category on Category {
    id
    slug
  }
`;
export const CoachListLelandPlusContributorCoachBatchResponseFragmentDoc = gql`
  fragment CoachListLelandPlusContributor_CoachBatchResponse on CoachBatchResponse {
    total
    results {
      id
      slug
      user {
        id
        firstName
        lastName
        pictureLink
      }
    }
  }
`;
export const CoachListOfferingPackageFragmentDoc = gql`
  fragment CoachList_OfferingPackage on OfferingPackage {
    ...CoachCard_OfferingPackage
  }
  ${CoachCardOfferingPackageFragmentDoc}
`;
export const CoachListSkuFragmentDoc = gql`
  fragment CoachList_Sku on Sku {
    ...CoachCard_Sku
  }
  ${CoachCardSkuFragmentDoc}
`;
export const CoachListHydratedCoachFieldsFragmentDoc = gql`
  fragment CoachList_HydratedCoachFields on Coach {
    ...CoachCard_HydratedCoachFields
  }
  ${CoachCardHydratedCoachFieldsFragmentDoc}
`;
export const CoachListUserDocument = gql`
  query CoachList_User {
    user {
      id
      applicant {
        id
        hasLelandPlusAccess
      }
    }
  }
`;

/**
 * __useCoachListUserQuery__
 *
 * To run a query within a React component, call `useCoachListUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachListUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachListUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoachListUserQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CoachListUserQuery,
    CoachListUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CoachListUserQuery, CoachListUserQueryVariables>(
    CoachListUserDocument,
    options,
  );
}
export function useCoachListUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoachListUserQuery,
    CoachListUserQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CoachListUserQuery, CoachListUserQueryVariables>(
    CoachListUserDocument,
    options,
  );
}
export function useCoachListUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoachListUserQuery,
        CoachListUserQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CoachListUserQuery,
    CoachListUserQueryVariables
  >(CoachListUserDocument, options);
}
export type CoachListUserQueryHookResult = ReturnType<
  typeof useCoachListUserQuery
>;
export type CoachListUserLazyQueryHookResult = ReturnType<
  typeof useCoachListUserLazyQuery
>;
export type CoachListUserSuspenseQueryHookResult = ReturnType<
  typeof useCoachListUserSuspenseQuery
>;
export type CoachListUserQueryResult = Apollo.QueryResult<
  CoachListUserQuery,
  CoachListUserQueryVariables
>;
export const CoachListHydratedCoachesBySlugsDocument = gql`
  query CoachList_HydratedCoachesBySlugs($coachUrns: [String!]!) {
    coachesBySlugs(slugs: $coachUrns) {
      ...CoachList_HydratedCoachFields
    }
  }
  ${CoachListHydratedCoachFieldsFragmentDoc}
`;

/**
 * __useCoachListHydratedCoachesBySlugsQuery__
 *
 * To run a query within a React component, call `useCoachListHydratedCoachesBySlugsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachListHydratedCoachesBySlugsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachListHydratedCoachesBySlugsQuery({
 *   variables: {
 *      coachUrns: // value for 'coachUrns'
 *   },
 * });
 */
export function useCoachListHydratedCoachesBySlugsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoachListHydratedCoachesBySlugsQuery,
    CoachListHydratedCoachesBySlugsQueryVariables
  > &
    (
      | {
          variables: CoachListHydratedCoachesBySlugsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CoachListHydratedCoachesBySlugsQuery,
    CoachListHydratedCoachesBySlugsQueryVariables
  >(CoachListHydratedCoachesBySlugsDocument, options);
}
export function useCoachListHydratedCoachesBySlugsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoachListHydratedCoachesBySlugsQuery,
    CoachListHydratedCoachesBySlugsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CoachListHydratedCoachesBySlugsQuery,
    CoachListHydratedCoachesBySlugsQueryVariables
  >(CoachListHydratedCoachesBySlugsDocument, options);
}
export function useCoachListHydratedCoachesBySlugsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CoachListHydratedCoachesBySlugsQuery,
        CoachListHydratedCoachesBySlugsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CoachListHydratedCoachesBySlugsQuery,
    CoachListHydratedCoachesBySlugsQueryVariables
  >(CoachListHydratedCoachesBySlugsDocument, options);
}
export type CoachListHydratedCoachesBySlugsQueryHookResult = ReturnType<
  typeof useCoachListHydratedCoachesBySlugsQuery
>;
export type CoachListHydratedCoachesBySlugsLazyQueryHookResult = ReturnType<
  typeof useCoachListHydratedCoachesBySlugsLazyQuery
>;
export type CoachListHydratedCoachesBySlugsSuspenseQueryHookResult = ReturnType<
  typeof useCoachListHydratedCoachesBySlugsSuspenseQuery
>;
export type CoachListHydratedCoachesBySlugsQueryResult = Apollo.QueryResult<
  CoachListHydratedCoachesBySlugsQuery,
  CoachListHydratedCoachesBySlugsQueryVariables
>;
